import React, { Suspense, lazy, useContext, useEffect } from 'react';
import { Router, Redirect, RouteComponentProps, navigate } from '@reach/router';
import { AuthContext, EAuthAdminRole } from '../core/context';

const ClientLayout = lazy(() => import('./client/ClientLayout'));
const ScopeLayout = lazy(() => import('./scope/ScopeLayout'));
const UserLayout = lazy(() => import('./user/UserLayout'));
const FirmLayout = lazy(() => import('./firm/FirmLayout'));
const BrandLayout = lazy(() => import('./brand/BrandLayout'));
const AdminLayout = lazy(() => import('./admin/AdminLayout'));
const TokenLayout = lazy(() => import('./token/TokenLayout'));
const NoAccessPage = lazy(() => import('./no-access/NoAccess'));

const Routes = () => {
  const authContext = useContext(AuthContext);
  const NotFound = (props: RouteComponentProps) => <p>Sorry, nothing here</p>;

  useEffect(() => {
    if (authContext.role === EAuthAdminRole.Azure) {
      navigate('/token');
    }
  }, [authContext.role]);

  return (
    <Suspense fallback={<span>still working hard to deliver your content...</span>}>
      <Router>
        <ClientLayout path="client/*" />
        <ScopeLayout path="scope/*" />
        <TokenLayout path="token/*" />
        {authContext.role === EAuthAdminRole.Admin && (
          <>
            <UserLayout path="user/*" />
            <FirmLayout path="firm/*" />
            <BrandLayout path="brand/*" />
            <AdminLayout path="admin/*" />
          </>
        )}

        <NoAccessPage path="no-access" />
        <Redirect noThrow from="/" to="client"></Redirect>
        <NotFound default />
      </Router>
    </Suspense>
  );
};

export { Routes };
